import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Avatar, Box, Divider, IconButton, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import buildInfo from 'src/buildInfo.json';
import { getUser, handleLogoutMain } from 'src/utils/Common';
import { closeAlert, getTasksRequest } from '../../store/actions';
import { useOktaAuth } from '@okta/okta-react';

const ORANGE = '#FF9800';
const DARK = '#424242';

const useStyles = makeStyles((theme) => ({
  // Uygulamadaki tek üst bar: tam genişlik, sol menünün (Drawer) üstünde
  appBar: {
    backgroundColor: DARK,
    boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
    zIndex: theme.zIndex.drawer + 1
  },
  toolbar: {
    backgroundColor: DARK,
    gap: '8px'
  },
  brand: {
    fontFamily: 'Segoe UI',
    fontSize: '22px',
    fontWeight: 600,
    color: ORANGE,
    lineHeight: 1,
    userSelect: 'none'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    height: '24px',
    padding: '0 8px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    fontFamily: 'Segoe UI'
  },
  badgeDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%'
  },
  iconButton: {
    color: ORANGE,
    '&:hover': { backgroundColor: 'rgba(255,152,0,0.12)' }
  },
  avatarButton: {
    padding: '2px',
    border: '2px solid transparent',
    transition: 'border-color 0.15s',
    '&:hover': { borderColor: ORANGE }
  }
}));

function TopBar({ onOpenNavBar, changeTopBarRotation }) {
  const classes = useStyles();
  const [, setExpireTime] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const SessionUser = getUser() || {};
  const { oktaAuth } = useOktaAuth();

  const fullName = `${SessionUser.FirstName || ''} ${SessionUser.LastName || ''}`.trim();
  const initials = `${(SessionUser.FirstName || '').trim().charAt(0)}${(SessionUser.LastName || '').trim().charAt(0)}`.toLocaleUpperCase('tr-TR');
  const version = buildInfo && buildInfo.version;

  const setMenuShowFnc = () => {
    changeTopBarRotation()
    onOpenNavBar();
  }

  useEffect(() => {
    try {
      var control = localStorage.getItem('okta-token-storage') || '{}';
      var timestamp = JSON.parse(control).accessToken.expiresAt

      var formatedDate = new Intl.DateTimeFormat('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(timestamp * 1000)
      setExpireTime(formatedDate);
    } catch (e) {
      // token bilgisi okunamazsa üst bar yine çalışır
    }
  }, []);

  const Logout = async () => {
    setMenuAnchor(null);
    handleLogoutMain();
    await oktaAuth.signOut();
  };

  return (
    <AppBar
      className={classes.appBar}
      position="fixed"
    >
      <Toolbar className={classes.toolbar}>
        <IconButton className={classes.iconButton} onClick={setMenuShowFnc} edge="start">
          <MenuIcon />
        </IconButton>
        <Typography component="div" className={classes.brand} noWrap>
          Dia
        </Typography>

        <Box sx={{ flex: 1 }} />

        {version && (
          <Tooltip title={buildInfo.sha ? `Sürüm ${version} · ${buildInfo.sha}` : `Sürüm ${version}`}>
            <span
              className={classes.badge}
              style={{ color: '#66bb6a', backgroundColor: 'rgba(102,187,106,0.12)', border: '1px solid rgba(102,187,106,0.4)' }}
            >
              <span className={classes.badgeDot} style={{ backgroundColor: '#66bb6a' }} />
              v{version}
            </span>
          </Tooltip>
        )}
        <Tooltip title={fullName || 'Kullanıcı'}>
          <IconButton className={classes.avatarButton} onClick={(e) => setMenuAnchor(e.currentTarget)}>
            <Avatar sx={{ width: 36, height: 36, backgroundColor: '#fff3e0', color: ORANGE, fontSize: '14px', fontWeight: 600 }}>
              {initials || '?'}
            </Avatar>
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={() => setMenuAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ sx: { mt: 1, minWidth: 240, borderRadius: '12px', boxShadow: '0 6px 20px rgba(0,0,0,0.15)' } }}
        >
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#263238' }}>{fullName || 'Kullanıcı'}</Typography>
            {SessionUser.UserId && (
              <Typography sx={{ fontSize: '12px', color: '#78909c' }}>Sicil No: {SessionUser.UserId}</Typography>
            )}
            {SessionUser.ServiceShopName && (
              <Typography sx={{ fontSize: '12px', color: '#78909c' }} noWrap>
                {[SessionUser.ServiceShopCode, SessionUser.ServiceShopName].filter(Boolean).join(' - ')}
              </Typography>
            )}
          </Box>
          <Divider />
          <MenuItem onClick={() => Logout()} sx={{ fontSize: '13px', fontWeight: 600, color: '#c62828', py: 1.25 }}>
            <LogoutIcon sx={{ fontSize: 18, mr: 1.5 }} />
            Çıkış Yap
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBar: PropTypes.func
};

export default connect(
  state => ({ alertReducer: state.alertReducer }),
  {
    getTasksRequest, closeAlert
  }
)(TopBar);
